// extracted by mini-css-extract-plugin
export default {"container":"AspectRatioContainer_container__ETLBp","containerInner":"AspectRatioContainer_containerInner__zlZvh","containerOuter":"AspectRatioContainer_containerOuter__E9WwK"};